import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import './ArtistPreview.css';

const studios = { 1: 'Essen', 2: 'Münster', 3: 'Dortmund' };
export default function ArtistPreview() {
  const { user } = useAuth();
  const [expanded, setExpanded] = useState(false);
  const [studio, setStudio] = useState('1');
  const [accounts, setAccounts] = useState([]);
  const [artistUserId, setArtistUserId] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (user?.role !== 'owner' || !expanded) return;
    let active = true;
    axios.get('/api/auth/impersonation/artists').then(r => {
      if (active) setAccounts(Array.isArray(r.data) ? r.data : []);
    }).catch(() => { if (active) setError('Unable to load artist accounts.'); });
    return () => { active = false; };
  }, [user?.role, expanded]);
  if (user?.role !== 'owner') return null;
  const filtered = accounts.filter(a => String(a.locationId) === studio);
  const enter = async () => {
    if (!artistUserId || busy) return;
    setBusy(true); setError('');
    try {
      await axios.post('/api/auth/impersonation/start', { artistUserId: Number(artistUserId) });
      window.location.assign('/artist');
    } catch (e) {
      setError(e.response?.data?.message || 'Artist login failed.');
      setBusy(false);
    }
  };
  return <section className="artist-preview-widget">
    <button type="button" className="artist-preview-toggle" onClick={() => setExpanded(v => !v)} aria-expanded={expanded}>
      <span>◉ &nbsp; Artist Login</span><span>{expanded ? '−' : '+'}</span>
    </button>
    {expanded && <div className="artist-preview-inner">
      <p>Owner only · Log in to the real artist account without a password. Actions and messages are live.</p>
      <div className="artist-preview-controls">
        <label>Studio<select value={studio} onChange={e => { setStudio(e.target.value); setArtistUserId(''); }}>
          {Object.entries(studios).map(([id, name]) => <option key={id} value={id}>{name}</option>)}
        </select></label>
        <label>Artist<select value={artistUserId} onChange={e => setArtistUserId(e.target.value)}>
          <option value="">Choose an artist</option>
          {filtered.map(a => <option key={a.userId} value={a.userId}>{a.name}</option>)}
        </select></label>
        <button type="button" disabled={!artistUserId || busy} onClick={enter}>{busy ? 'Logging in…' : 'Login as Artist →'}</button>
      </div>
      {filtered.length === 0 && <p>No active artist accounts at this studio.</p>}
      {error && <p role="alert" className="artist-preview-error">{error}</p>}
    </div>}
  </section>;
}
